import React from 'react'
import { Link } from 'react-router-dom'
import { makeStyles, useTheme } from '@material-ui/core/styles'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import IconButton from '@material-ui/core/IconButton'
import ExitToApp from '@material-ui/icons/ExitToApp'
import Brightness7Icon from '@material-ui/icons/Brightness7'
import Brightness4Icon from '@material-ui/icons/Brightness4'

import { signout } from '../api/auth'
import { useMediaQuery } from '@material-ui/core'

const useStyles = makeStyles(() => ({
  root: {
    flexGrow: 1,
  },
  link: {
    textDecoration: 'none',
    display: 'flex'
  },
  title: {
    color: 'white',
    lineHeight: 1
  },
  subTitle: {
    marginLeft: 6
  },
  toolbar: {
    justifyContent: 'space-between'
  }
}))

const MenuAppBar = ({ email, isAuthenticated, isDarkModeEnabled, setIsDarkModeEnabled }) => {
  const theme = useTheme()
  const isSmall = useMediaQuery(theme.breakpoints.down('xs'))
  const classes = useStyles()

  const onSignout = async () => {
    await signout()
  }

  return (
    <div className={classes.root}>
      <AppBar position='static' css={`
        background-color: ${isDarkModeEnabled ? '#474e75' : ''};
      `}>
        <Toolbar classes={{ root: classes.toolbar }} css={`
          padding-left: ${isSmall ? '8' : '14'}px;
          padding-right: ${isSmall ? '0' : '4'}px;
          ${isSmall ? 'min-height: 50px;' : ''}
        `}>
          <div css={`display: flex; flex-direction: column;`}>
            <Link to='/' className={classes.link}>
              <Typography variant='h5' className={classes.title}>
                swroller
              </Typography>
              {/* {isAuthenticated &&
                <Typography variant='h6' className={[classes.title, classes.subTitle]}>
                  {campaignName}
                </Typography>
              } */}
            </Link>
            {isSmall && <div css={`font-size: 11px;`}>{email}</div>}
          </div>
          {isAuthenticated && (
            <div>
              {!isSmall && <span>{email}</span>}
              <IconButton
                css={`margin-left: 12px;`}
                color='inherit'
                title='Toggle dark mode'
                onClick={() => {
                  setIsDarkModeEnabled(!isDarkModeEnabled)
                  window.localStorage.setItem('swroller-darkmode', !isDarkModeEnabled)
                }}
              >
                {isDarkModeEnabled ?
                  <Brightness4Icon />
                  :
                  <Brightness7Icon />
                }
              </IconButton>
              <IconButton
                title='Sign out'
                onClick={() => {
                  const result = window.confirm('Are you sure you want to sign out?')
                  if (result) onSignout()
                }}
                color='inherit'
              >
                <ExitToApp />
              </IconButton>
            </div>
          )}
        </Toolbar>
      </AppBar>
    </div>
  )
}

export default MenuAppBar
